import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { IconButtonComponent, TooltipDirective } from '@mode/capra';
import { ClipboardDirective } from '@mode/shared/ui';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';
import { ColorDropperComponent } from '../color-dropper/color-dropper.component';
import { HexInputComponent } from '../hex-input/hex-input.component';

@Component({
  selector: 'mode-color-toolbar',
  standalone: true,
  imports: [
    ClipboardDirective,
    ColorDropperComponent,
    CommonModule,
    HexInputComponent,
    IconButtonComponent,
    TooltipDirective,
  ],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorToolbarComponent implements OnChanges {
  @Input() currentColor = '';
  @Input() savedColor = '';
  @Output() colorUpdated = new EventEmitter<string>();

  constructor(private analyticsService: AnalyticsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentColor']) {
      this.currentColor = this.formatColor(this.currentColor);
    }
  }

  formatColor(color: string) {
    return color.replace('#', '').toUpperCase();
  }

  formatHex(hex: string) {
    if (hex.length === 3) {
      return `#${hex.replace(/./g, '$&$&').toUpperCase()}`;
    }
    return `#${hex.toUpperCase()}`;
  }

  onResetClick() {
    this.currentColor = this.formatColor(this.savedColor);
    this.colorUpdated.emit(this.formatHex(this.currentColor));

    this.analyticsService.track(AnalyticsEvent.Name.UiClicked, {
      location: AnalyticsEvent.SubContext.EditColorsModal,
      action: 'Reset Flyout Color Click',
      context: AnalyticsEvent.Context.Visualization,
    });
  }

  onColorSelected(color: string) {
    this.currentColor = this.formatColor(color);
    this.colorUpdated.emit(this.formatHex(this.currentColor));
  }
}
